import * as React from 'react'
import { INVESTOR_TOP_LIST_COUNT } from '../../../pages/investors/[shortname]'
import { InvestorNews } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { ExternalNewsList } from './ExternalNewsList'
import { InvestorFinanceNewsList } from './InvestorFinanceNewsList'
import { ViewMoreLink } from '../../common/ViewMoreLink'
import { NewsPicksNewsList } from './NewsPicksNewsList'

type Props = {
  shortname: string
  news: InvestorNews
}

export const InvestorNewsSection: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle>ニュース</CardTitle>
      <InvestorFinanceNewsList list={props.news.finance.data} />
      <ViewMoreLink
        isHidden={props.news.finance.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/finance-news?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/finance-news`}
        count={props.news.finance.count}
      />
      <NewsPicksNewsList investorShortname={props.shortname} />
      <ExternalNewsList list={props.news.external.data} />
      <ViewMoreLink
        isHidden={props.news.external.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/external-news?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/external-news`}
        count={props.news.external.count}
      />
    </>
  )
}
